export enum eGigyaScreen {
    LOGIN = 'gigya-login-screen',
    RESET_PASSWORD = 'gigya-forgot-password-screen'
}